"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringToGenericInvoicingTarget = exports.toGenericInvoicingTarget = exports.isGeneralInvoicingTarget = exports.isInvoicingTarget = exports.GeneralInvoicingTargetEnum = exports.InvoicingTargetEnum = void 0;
var InvoicingTargetEnum;
(function (InvoicingTargetEnum) {
    InvoicingTargetEnum["BRAND"] = "Brand";
    InvoicingTargetEnum["BRAND_1"] = "Brand_1";
    InvoicingTargetEnum["BRAND_2"] = "Brand_2";
    InvoicingTargetEnum["CUSTOMER"] = "Kunde";
    InvoicingTargetEnum["GID"] = "GID";
    InvoicingTargetEnum["CUSTOMER_2"] = "Customer_2";
    InvoicingTargetEnum["AFFILIATE"] = "Affiliate";
})(InvoicingTargetEnum = exports.InvoicingTargetEnum || (exports.InvoicingTargetEnum = {}));
var GeneralInvoicingTargetEnum;
(function (GeneralInvoicingTargetEnum) {
    GeneralInvoicingTargetEnum["AFFILIATE"] = "affiliate";
    GeneralInvoicingTargetEnum["BRAND"] = "brand";
    GeneralInvoicingTargetEnum["BRAND_1"] = "brand_1";
    GeneralInvoicingTargetEnum["BRAND_2"] = "brand_2";
    GeneralInvoicingTargetEnum["CUSTOMER"] = "customer";
    GeneralInvoicingTargetEnum["GID"] = "gid";
    GeneralInvoicingTargetEnum["CUSTOMER_SECOND"] = "customer_second";
    GeneralInvoicingTargetEnum["PARTNER"] = "partner";
    GeneralInvoicingTargetEnum["SUPPLIER"] = "supplier";
})(GeneralInvoicingTargetEnum = exports.GeneralInvoicingTargetEnum || (exports.GeneralInvoicingTargetEnum = {}));
const invoicingTargetEnumValues = new Set(Object.values(InvoicingTargetEnum));
const generalInvoicingTargetEnumValues = new Set(Object.values(GeneralInvoicingTargetEnum));
function isInvoicingTarget(key) {
    return invoicingTargetEnumValues.has(key);
}
exports.isInvoicingTarget = isInvoicingTarget;
function isGeneralInvoicingTarget(key) {
    return generalInvoicingTargetEnumValues.has(key);
}
exports.isGeneralInvoicingTarget = isGeneralInvoicingTarget;
function toGenericInvoicingTarget(oldTarget) {
    switch (oldTarget) {
        case InvoicingTargetEnum.BRAND:
            return GeneralInvoicingTargetEnum.BRAND;
        case InvoicingTargetEnum.BRAND_1:
            return GeneralInvoicingTargetEnum.BRAND_1;
        case InvoicingTargetEnum.BRAND_2:
            return GeneralInvoicingTargetEnum.BRAND_2;
        case InvoicingTargetEnum.CUSTOMER:
            return GeneralInvoicingTargetEnum.CUSTOMER;
        case InvoicingTargetEnum.CUSTOMER_2:
            return GeneralInvoicingTargetEnum.CUSTOMER_SECOND;
        case InvoicingTargetEnum.AFFILIATE:
            return GeneralInvoicingTargetEnum.AFFILIATE;
        case InvoicingTargetEnum.GID:
            return GeneralInvoicingTargetEnum.GID;
        default:
            throw new Error(`[toGenericInvoicingTarget] Invalid invoicing target: ${oldTarget}`);
    }
}
exports.toGenericInvoicingTarget = toGenericInvoicingTarget;
function stringToGenericInvoicingTarget(target) {
    if (isGeneralInvoicingTarget(target)) {
        return target;
    }
    if (isInvoicingTarget(target)) {
        return toGenericInvoicingTarget(target);
    }
    throw new Error(`[stringToGenericInvoicingTarget] Unknown invoicing target: ${target}`);
}
exports.stringToGenericInvoicingTarget = stringToGenericInvoicingTarget;
//# sourceMappingURL=invoicing-target.js.map